import { graphql } from "react-relay";

export const teamSettingsAdminTeamCalendarFragments = {
  org: graphql`
    fragment TeamSettingsAdminTeamCalendar_org on Org
    @argumentDefinitions(teamId: { type: "String!" }) {
      id
      experiments
      teamSettings(teamId: $teamId) {
        __typename
        ... on TeamSettings {
          manageTeamCalendar
          syncWFHEvents
          minimumMinutesForSyncing
          slackSettings {
            notificationEnabled
            channelId
            timeSlot
          }
          m365TeamCalendarDetails {
            __typename
            ... on TeamCalendarDetails {
              calendarName
              members {
                status
                personId
              }
              owner {
                personId
                primaryCalendarId
                isYou
                profile {
                  givenName
                  familyName
                }
              }
            }
            ... on GraphEntityError {
              statusCode
              message
            }
          }
        }
        ... on GraphEntityError {
          statusCode
          message
        }
      }
    }
  `,
  team: graphql`
    fragment TeamSettingsAdminTeamCalendar_team on Team {
      id
      teamId
      teamName
      teamCalendarId
      teamMembers {
        person {
          __typename
          id
          userId
          personId
          primaryCalendarId
          isYou
          profile {
            givenName
            familyName
            externalImageUrl
          }
        }
      }
    }
  `,
};

export const refetchQuery = graphql`
  query TeamSettingsAdminTeamCalendarQuery($orgRelayId: ID!, $teamId: String!) {
    orgRefetch: node(id: $orgRelayId) {
      ... on Org {
        ...TeamSettingsAdminTeamCalendar_org @arguments(teamId: $teamId)
      }
    }
  }
`;
